<template>
  <div>
    <VueApexCharts
      :options="pieChart.options"
      :series="props.seriesData"
      width="410"
    ></VueApexCharts>
  </div>
</template>

<script setup>
import { reactive, defineProps } from "vue";
import VueApexCharts from "vue3-apexcharts";
const props = defineProps({
  seriesData: {
    type: Array,
    required: false,
  },
})

// * Pie Chart data
const pieChart = reactive({
  options: {
    chart: {
      width: 410,
      type: 'pie',
    },
    colors: ['#0c1e36', '#2B978D'],
    toolbar: {
      show: false
    },
    labels: ['00:00 - 04:00', '04:00 - 08:00', '08:00 - 12:00', '12:00 - 16:00', '16:00 - 20:00', '20:00 - 00:00'],
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          show: false
        }
      }
    }]
  },
});
</script>
